import { render } from "./DkBotInput.vue?vue&type=template&id=6c54425c"
import script from "./DkBotInput.vue?vue&type=script&lang=js"
export * from "./DkBotInput.vue?vue&type=script&lang=js"

import "./DkBotInput.vue?vue&type=style&index=0&id=6c54425c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__